import ConfigurablePane from './_configurable-pane.js'
import FlexItemBase from './_flex-item-base.js'
import AbsolutePane from './_absolute-pane.js'
import FlexPane from './_flex-pane.js'
import Image from './_image.js'
import ConfigurableText from './_configurable-text.js'
import Text from './_text.js'

export default {
  name: 'BetslipBet',
  values: {
    container: {
      position: 'relative',
      padding: '8px',
      $mixin: [
        {
          configSet: ConfigurablePane,
        },
        {
          configSet: FlexItemBase,
        },
      ],
    },
    highlightIndicator: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          width: '8px',
          height: '100%',
          left: 0,
          top: 0,
        },
      },
    },
    betInfoContainer: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          alignItems: 'flex-start',
        },
      },
    },
    stakeInfoContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexGrow: 0,
          flexShrink: 0,
          padding: '0 0 0 16px',
          flexDirection: 'column',
          alignItems: 'flex-end',
          alignSelf: 'stretch',
          justifyContent: 'space-between',
        },
      },
    },
    returnsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          alignItems: 'flex-end',
          padding: '4px 0px 0px',
        },
      },
    },
    matchAccaImage: {
      configSet: Image,
      configValues: {
        src: 'system-betbuilder',
        style: {
          minWidth: '16px',
          minHeight: '16px',
          padding: '0 8px 0 -8px',
        },
      },
    },
    betType: {
      margin: '0',
      $mixin: [
        {
          configSet: ConfigurableText,
        },
      ],
    },
    betTypeSuspended: {
      margin: '0',
      $mixin: [
        {
          configSet: ConfigurableText,
        },
      ],
    },
    multiplesInfo: {
      margin: '0 4px 0 0',
      $mixin: [
        {
          configSet: ConfigurableText,
        },
      ],
    },
    multiplesInfoSuspended: {
      margin: '0 4px 0 0',
      $mixin: [
        {
          configSet: ConfigurableText,
        },
      ],
    },
    price: {
      margin: 0,
      $mixin: [
        {
          configSet: ConfigurableText,
        },
      ],
    },
    updatedPrice: {
      margin: 0,
      $mixin: [
        {
          configSet: ConfigurableText,
        },
      ],
    },
    priceSuspended: {
      margin: 0,
      $mixin: [
        {
          configSet: ConfigurableText,
        },
      ],
    },
    updatedPriceSuspended: {
      margin: 0,
      $mixin: [
        {
          configSet: ConfigurableText,
        },
      ],
    },
    matchAccaHeaderContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '0 0 4px 0',
        },
      },
    },
    matchAccaHeader: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    matchAccaHeaderSuspended: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    matchAccaEventName: {
      configSet: Text,
      configValues: {},
    },
    matchAccaEventNameSuspended: {
      configSet: Text,
      configValues: {},
    },
    matchAccaSelectionsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '4px 0 0 0',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
